import { render, staticRenderFns } from "./closeButton.vue?vue&type=template&id=40c609d8"
import script from "./closeButton.vue?vue&type=script&lang=js"
export * from "./closeButton.vue?vue&type=script&lang=js"
import style0 from "./closeButton.vue?vue&type=style&index=0&id=40c609d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports